import React, { useState, useEffect, useContext } from 'react';
import Modal from "react-modal";
import axios from "axios";
import { getwayApi } from '../../../config/Constants'
import './styles/SummaryModal.scss'
// import {SectionHeader} from '../../components/sectionHeader/sectionHeader'
// import { testFormSpec } from '../../../context/formSpec_patient';
import Button from '../../components/Button/Button'
import { BackArrowIcon, Icon_BulletPoint, Icon_PBV, Icon_Warning, Icon_MedicalRecord, Icon_DropdownArrow, Icon_MedicalFacility, Icon_Doctor } from '../form/styles/assets/icons'
import { LogoAndTitle } from '../form/sections/LogoAndTitle_Section/LogoAndTitle'
import { object } from 'prop-types';
import { resetFormLists, doctorList, sensitiveInfoDisclosures, sensitiveInfoToggle, consoleLogs, convertSubmissionObject } from './logic'
import './summaryModal.scss'
import { CloseIcon } from '../form/styles/assets/icons'
import { ConfigContext } from '../form/DynamicForm/DynamicForm';

export const SummaryModalMultiLanguage = ({ config, submitData, isModelOpen, setSummary, logo, formId, formik, testFormSpec, setNextPage, formType, languageText }) => {
    const [closeModal, setCloseModal] = useState(isModelOpen)
    const [sensitiveInfoDropped, setSensitiveInfoDropped] = useState(false)

    const { dbFormSpec } = useContext(ConfigContext);

    const userInput = formik.values;

    // document.getElementsByTagName('body')[0].style.overflow = 'hidden'

    const submitForm = async () => {
        convertSubmissionObject(formik, dbFormSpec.facility.orgId, outPatientSummaryList).then((value) => {
            setNextPage(true);
            submitData(value);
        })
    };

    useEffect(() => {
        dbFormSpec.facility.orgId.includes('7307') ? console.log('') : formik.setFieldValue('pdf_facilitiesList', formik.values.facilityList.join(',  '))
    }, [formik.values.facilityList]);
    // REFACTOR TO ADD THIS TO SELECTANDTYPE COMPONENT

    useEffect(() => {
        userInput.PPhone === '' && formik.setFieldValue('PPhone', 'No Phone Provided')
        if (userInput.PPhone === 'No Phone Provided') {
            return () => { formik.setFieldValue('PPhone', '') }
        }
    }, [formik.values.PPhone]);

    useEffect(() => {
        userInput.PEmail === '' && formik.setFieldValue('PEmail', 'No Email Provided')
        if (userInput.PEmail === 'No Email Provided') {
            return () => { formik.setFieldValue('PEmail', '') }
        }
    }, [formik.values.PEmail, formik.values.PPhone])

    useEffect(() => { formik.setFieldValue('languageOverride', dbFormSpec.languageOverride); }, []);

    const resetFormLists = () => {
        let values = userInput
        for (let property in values) {
            if (property.includes('requesteditem') || property.includes('inputAuthorizeFacility') || property.includes('exclude')) {
                delete values[property];
            }
        }
        // formik.setValues({...values, test: 'test'})
        formik.values.inputPhysicianNames !== 'not_applicable' && formik.setFieldValue('inputPhysicianNames', "")
        // Clear the names stored on inputPhysicianName in case user makes new selections on resubmit
        // formik.setFieldValue('txtotherrecords', "")
        // Clear the names stored on txtotherrecords in case user makes new selections on resubmit
    }

    const ui = userInput;




    const patientInputObjML = {
        sectionTitle: languageText.SummaryModal.Titles.PatInfo,
        values: {
            name: `${ui.PFName} ${ui.PMName} ${ui.PLName}`,
            phone: ui.PPhone,
            email: ui.PEmail,
            date_of_birth: ui.PDOB,
            patient_address: `${ui.PAddress1} ${ui.PAddress2} ${ui.PCity}, ${ui.PState} ${ui.PZip}`,
            maiden_or_other_name: ui.POName
        },
        translatedValues:
        {
            name: `${languageText.SummaryModal.Labels.name}`,
            phone: `${languageText.SummaryModal.Labels.phone}`,
            email: languageText.SummaryModal.Labels.email,
            date_of_birth: languageText.SummaryModal.Labels.date_of_birth,
            patient_address: languageText.SummaryModal.Labels.patient_address,
            maiden_or_other_name: languageText.SummaryModal.Labels.maiden_or_other_name
        }
    };


    const repInputObjML = {
        sectionTitle: languageText.SummaryModal.Titles.RepInfo,
        values: {
            name: `${ui.RepFName} ${ui.RepMName} ${ui.RepLName}`,
            phone: ui.RepPhone,
            email: ui.RepEmail,
            relationship_to_patient: ui.rrelationship,
            address: `${ui.RepAddress1} ${ui.RepAddress2} ${ui.RepCity}, ${ui.RepState} ${ui.RepZip}`
        },
        translatedValues: {
            name: languageText.SummaryModal.Labels.name,
            phone: languageText.SummaryModal.Labels.phone,
            email: languageText.SummaryModal.Labels.email,
            relationship_to_patient: languageText.SummaryModal.Labels.relationship_to_patient,
            address: languageText.SummaryModal.Labels.address
        }
    }


    const deliveryInputObjML = {
        sectionTitle: languageText.SummaryModal.Titles.RecordsDelivery,
        values: {
            recipient_name: ui.RName,
            recipient_phone: ui.RPhone,
            recipient_email: ui.REmail,
            recipient_fax: ui.RFax,
            recipient_address: ui.pdf_RAddress,
            delivery_method: ui.pdf_deliveryMethod,
        },
        translatedValues: {
            recipient_name: languageText.SummaryModal.Labels.recipient_name,
            recipient_phone: languageText.SummaryModal.Labels.recipient_phone,
            recipient_email: languageText.SummaryModal.Labels.recipient_email,
            recipient_fax: languageText.SummaryModal.Labels.recipient_fax,
            recipient_address: languageText.SummaryModal.Labels.recipient_address,
            delivery_method: languageText.SummaryModal.Labels.delivery_method,
        }
    }
    //Filter out the entries with empty text
    const filteredLog = Object.keys(ui).reduce((newObj, key) => {
        if ((ui[key]) && ui[key] !== "") {
            newObj[key] = ui[key];
        }
        return newObj;
    }, {});


    //Populate the facility list for the summary page and the fax.
    const outPatientSummaryList = `${Object.keys(filteredLog).filter((key) => { return key.includes('CustomTextbox_') }).map((key) => { return `${key.replace('CustomTextbox_', '')}: ${filteredLog[key]}` }).join('   |   ')}`




    const recordsInputObjML = {
        sectionTitle: languageText.SummaryModal.Titles.MedRecord,
        values: {
            medical_records_released: ui.pdf_releaseItemsList,
            sensitive_info_released: dbFormSpec.facility.orgId.includes('7042') ? ui.pdf_sensitiveInfoList : null,
            dates_of_service: ui.pdf_serviceDates,
            facilities_releasing_info: ui.pdf_facilitiesList,
            other_facilities: ui.facilityOther,
            outpatient_facilities: outPatientSummaryList,
            request_purpose: ui.disclosurePurposeGroup,
            additional_information: ui.OtherNote
        },
        translatedValues: {
            medical_records_released: languageText.SummaryModal.Labels.medical_records_released,
            sensitive_info_released: dbFormSpec.facility.orgId.includes('7042') ? languageText.SummaryModal.Labels.sensitive_info_released : null,
            dates_of_service: languageText.SummaryModal.Labels.dates_of_service,
            facilities_releasing_info: languageText.SummaryModal.Labels.facilities_releasing_info,
            other_facilities: languageText.SummaryModal.Labels.other_facilities,
            outpatient_facilities: languageText.SummaryModal.Labels.outpatient_facilities,
            request_purpose: languageText.SummaryModal.Labels.request_purpose,
            additional_information: languageText.SummaryModal.Labels.additional_information
        }
    }


    const patientInputObj = {
        sectionTitle: languageText.SummaryModal.Titles.PatInfo,
        values: {
            name: `${ui.PFName} ${ui.PMName} ${ui.PLName}`,
            phone: ui.PPhone,
            email: ui.PEmail,
            date_of_birth: ui.PDOB,
            patient_address: `${ui.PAddress1} ${ui.PAddress2} ${ui.PCity}, ${ui.PState} ${ui.PZip}`,
            maiden_or_other_name: ui.POName
        }
    }

    const repInputObj = {
        sectionTitle: languageText.SummaryModal.Titles.RepInfo,
        values: {
            name: `${ui.RepFName} ${ui.RepMName} ${ui.RepLName}`,
            phone: ui.RepPhone,
            email: ui.RepEmail,
            relationship_to_patient: ui.rrelationship,
            address: `${ui.RepAddress1} ${ui.RepAddress2} ${ui.RepCity}, ${ui.RepState} ${ui.RepZip}`
        }
    }


    const deliveryInputObj = {
        sectionTitle: languageText.SummaryModal.Titles.RecordsDelivery,
        values: {
            recipient_name: ui.RName,
            recipient_phone: ui.RPhone,
            recipient_email: ui.REmail,
            recipient_fax: ui.RFax,
            recipient_address: ui.pdf_RAddress,
            delivery_method: ui.pdf_deliveryMethod,
        }
    }



    const recordsInputObj = {
        sectionTitle: languageText.SummaryModal.Titles.MedRecord,
        values: {
            medical_records_released: ui.pdf_releaseItemsList,
            sensitive_info_released: dbFormSpec.facility.orgId.includes('7042') ? ui.pdf_sensitiveInfoList : null,
            dates_of_service: ui.pdf_serviceDates,
            facilities_releasing_info: ui.pdf_facilitiesList,
            other_facilities: ui.facilityOther,
            outpatient_facilities: outPatientSummaryList,
            request_purpose: ui.disclosurePurposeGroup,
            additional_information: ui.OtherNote
        }
    }
    let footerText = dbFormSpec.CustomSummaryFooterText || languageText.SummaryModal.Text.SubmitDisclaimer;

    return (
        <div className="summary-modal">




            <div className='summary-content'>
                <div className="header">
                    <LogoAndTitle formId={formId} titleText={`${languageText.SummaryModal.Titles.RequestSummary}`} titleColor={'#717275'} dbFormSpec={config} />
                    <div className='close-link' onClick={() => { setCloseModal(false); setSummary(false); resetFormLists(); }}>
                        <p className="link-text">{languageText.SummaryModal.Text.BackToForm}</p>
                        <CloseIcon color={'black'} />
                    </div>
                </div>

                <div id="summary-sections">

                    <div className='wrapping-sec-container'>
                        <WrappingSecMultiLanguage config={config} sectionInputs={patientInputObjML} />
                        {formType === 'Representative' && <WrappingSecMultiLanguage config={config} sectionInputs={repInputObjML} />}
                        <WrappingSecMultiLanguage config={config} sectionInputs={deliveryInputObjML} />
                    </div>
                    <div className='summary-sec'>
                        <WrappingSecMultiLanguage config={config} sectionInputs={recordsInputObjML} />
                    </div>

                </div>

                <div id='summary-buttons'>
                    <p className='statement' style={{ marginBottom: 19 }}>
                        {footerText}
                        {/* <br/>
                        <br/>
                        If a fee does apply, you will be notified before your request is processed. */}
                    </p>

                    <Button label={`${languageText.SummaryModal.Buttons.SubmitText}`} type='submit' onClick={
                        () => {

                            formik.values.infoToReleaseGroup.forEach((item) => {
                                formik.values = { ...formik.values, [item]: 'on' }
                            })

                            submitForm();
                        }
                    } style={{ backgroundColor: testFormSpec.color }} classes={'submit-button'} />
                </div>
                <div id="summary-dates">
                    <p className='statement' style={{ marginBottom: 19 }}>
                        {languageText.SummaryModal.TodaysDate}  <b>{userInput.RequestDate}</b>
                        {languageText.SummaryModal.ExpirationDate}   <b>{userInput.expirationdate}</b>.
                    </p>
                </div>
                <Icon_PBV />
            </div>
        </div>
    )

}


const WrappingSecMultiLanguage = ({ sectionInputs, config }) => {
    return (
        <div className='summary-sec wrapping-sec'>
            <h5 style={{ color: config.color }}>{sectionInputs.sectionTitle}</h5>
            <div className='sec-columns'>
                <div className='column'>
                    {Object.entries(sectionInputs.values).map((valuePair, index) => {
                        if (index < 3 && valuePair[1] && !valuePair[1].includes('undefined')) {
                            let itemText = valuePair[1];
                            let itemKey = valuePair[0];
                            let itemLabel = sectionInputs.translatedValues[itemKey];
                            return (
                                <div className="value-pair">
                                    <p className="overline">{itemLabel}</p>
                                    <p className="body1">{itemText}</p>
                                </div>
                            )
                        }
                    })}
                </div>
                <div className='column'>
                    {Object.entries(sectionInputs.values).map((valuePair, index) => {
                        if (index >= 3 && valuePair[1] && !valuePair[1].includes('undefined')) {

                            let itemText = valuePair[1];
                            let itemKey = valuePair[0];
                            let itemLabel = sectionInputs.translatedValues[itemKey];
                            return (
                                <div className="value-pair">
                                    <p className="overline">{itemLabel}</p>
                                    <p className="body1">{itemText}</p>
                                </div>
                            )
                        }
                    })}
                </div>
            </div>

        </div>
    )
}


const WrappingSec = ({ sectionInputs, config }) => {
    return (
        <div className='summary-sec wrapping-sec'>
            <h5 style={{ color: config.color }}>{sectionInputs.sectionTitle}</h5>
            <div className='sec-columns'>
                <div className='column'>
                    {Object.entries(sectionInputs.values).map((valuePair, index) => {
                        if (index < 3 && valuePair[1] && !valuePair[1].includes('undefined')) {
                            return (
                                <div className="value-pair">
                                    <p className="overline">{valuePair[0].replaceAll('_', ' ')}</p>
                                    <p className="body1">{valuePair[1]}</p>
                                </div>
                            )
                        }
                    })}
                </div>
                <div className='column'>
                    {Object.entries(sectionInputs.values).map((valuePair, index) => {
                        if (index >= 3 && valuePair[1] && !valuePair[1].includes('undefined')) {
                            return (
                                <div className="value-pair">
                                    <p className="overline">{valuePair[0].replaceAll('_', ' ')}</p>
                                    <p className="body1">{valuePair[1]}</p>
                                </div>
                            )
                        }
                    })}
                </div>
            </div>

        </div>
    )
}



